import { ModalClose } from "../modalToggle";
const nameClass: string = "js-info-name";
const nameSubmitClass: string = "js-info-name-submit";
const nameInputClass: string = "js-info-name-input";
document.addEventListener("click", (event: any) => {
  const infoNameSubmit: HTMLElement = event.target.closest(`.${nameSubmitClass}`)!;
  if(infoNameSubmit) {
    const input: HTMLInputElement = document.querySelector(`.${nameInputClass}`)!;
    const inputValue: string = input.value;
    const name: HTMLElement = document.querySelector(`.${nameClass}`)!;
    name.innerText = inputValue;
    ModalClose();
  }
})
